import { useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_CHANNEL } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { UpdateChannelInput } from "src/interfaces/channel.interface";

export const useUpdateChannel = () => {
  const { axBe } = useAxiosInterceptor();
  const [isUpdatingChannel, setIsUpdatingChannel] = useState(false);

  const updateChannel = async (
    updateChannelInput: UpdateChannelInput,
    callbacks?: {
      onSuccess?: () => void;
      onError?: (error: unknown) => void;
    }
  ) => {
    setIsUpdatingChannel(true);
    try {

      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_CHANNEL,
        variables: { updateChannelInput: { ...updateChannelInput } },
      });

      if (data?.errors?.length) {
        throw data?.errors[0];
      }

      successToast("Channel has been updated successfully!");
      callbacks?.onSuccess?.();
    } catch (error) {
      console.error("Error updating channel:", error);
      callbacks?.onError?.(error);
    } finally {
      setIsUpdatingChannel(false);
    }
  };

  return {
    updateChannel,
    isUpdatingChannel,
  };
};

